"use client";

import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFirstClassStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="138742" id="the-three-dimensional-philosophy" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 flex items-center justify-center min-h-[80vh] bg-[radial-gradient(circle_at_center,theme(colors.primary/0.15)_0%,var(--color-background)_75%)]">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[12rem] sm:text-[20rem] md:text-[30rem] font-serif italic opacity-5 pointer-events-none select-none whitespace-nowrap text-primary z-0" aria-hidden="true">
        3D
      </div>

      <div ref={ref} className={`container mx-auto px-6 relative z-10 max-w-5xl flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5 mb-10 tracking-[0.2em] uppercase text-xs py-1.5 px-4 rounded-none">
          01 / Philosophy
        </Badge>

        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-16 text-foreground leading-[1.1] max-w-4xl">
          The Three-Dimensional Outlook
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 text-left text-muted-foreground tracking-wide leading-relaxed text-base sm:text-lg max-w-4xl font-sans">
          <div>
            <p>
              WealthCraft operates on a non-traditional axis where financial literacy 
              meets creative growth. We believe true prosperity requires a multi-layered 
              strategy that transcends standard investment models to build resilient, 
              liquid assets for the modern era.
            </p>
          </div>
          <div>
            <p>
              Our protection-first methodology integrates accelerated living benefits 
              and hybrid annuities to craft a self-made pension. We don&apos;t just manage 
              wealth; we engineer institutional-grade security that evolves with your 
              life, health, and legacy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}